import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaTrackDirective } from './ga-track.directive';

@NgModule({
  declarations: [GaTrackDirective],
  exports: [GaTrackDirective],
  imports: [CommonModule],
})
export class SharedModule {}
